import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import PapperBlock from "../PapperBlock/PapperBlock";
import useStyles from "../SocialMedia/jss/socialMedia-jss";
import NewsItem from "./NewsItem";

function LatestNews() {
  const theme = useTheme();
  const { classes, cx } = useStyles();

  return (
    <div>
      {/* Trending */}
      <PapperBlock
        title="latest News"
        icon="ion-ios-flame-outline"
        whiteBg
        desc=""
      >
        <List dense className={classes.trendingList}>
          {/* <ListItem className={classes.noPadding}>
            <a href="#" className={classes.link}>
              #Lorem ipsum dolor
            </a>
            <ListItemText secondary="2987 Posts" />
          </ListItem> */}

          <ListItem>
            <NewsItem text="test1" />
          </ListItem>
        </List>
      </PapperBlock>
    </div>
  );
}

export default LatestNews;
